var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"cus-Btn",class:[_vm.Color(_vm.colorType), _vm.userTheme ? `${_vm.Color(_vm.colorType)}-${_vm.userTheme}` : ''],attrs:{"plain":"","small":"","height":_vm.height,"disabled":_vm.disabled,"width":_vm.width},on:{"click":_vm.doFunction}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }